import { render } from "./LoginAsAgent.vue?vue&type=template&id=3b2a31c1"
import script from "./LoginAsAgent.vue?vue&type=script&lang=js"
export * from "./LoginAsAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__